import { render } from "./MainHelpMe.vue?vue&type=template&id=3c466a16"
import script from "./MainHelpMe.vue?vue&type=script&lang=js"
export * from "./MainHelpMe.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__